import type { WhoamiMe } from "@shared-domain/auth-service/contract";
import type { LoginPageTenant } from "../types";

/**
 * テナント選択 UI
 */
export const TenantSelect: React.FC<{
  user: WhoamiMe;
  tenants: LoginPageTenant[];
  onSelect: (tenant: LoginPageTenant) => void;
  handleClickLogout: () => void;
}> = ({ user, tenants, onSelect, handleClickLogout }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md space-y-4">
        <h2 className="text-2xl font-bold text-center mb-4">
          {user.user.name}さん、
          <br />
          テナントを選択してください。
        </h2>
        {tenants.map((t) => (
          <button
            key={t.tenantId}
            className="block w-full py-3 px-6 border rounded-lg text-left hover:bg-neutral-50"
            onClick={() => onSelect(t)}
          >
            <span className="text-lg text-primary mr-2">{t.tenantName}</span>
            <span className="text-sm text-gray-500">{t.role}</span>
          </button>
        ))}
      </div>

      {/* ログアウト */}
      <button
        type="submit"
        onClick={handleClickLogout}
        className={`
          w-80 bg-gray-500 hover:bg-gray-600 text-white
          mt-10 py-3 rounded-2xl text-xl font-bold transition-colors
        `}
      >
        ログアウト
      </button>
    </div>
  );
};
